import { Outlet } from 'react-router-dom';
import type { CSSProperties } from 'react';
import Footer from '@/components/organisms/Footer';
import { SidebarProvider } from '../atoms/Sidebar';
import { AppSidebar } from '../organisms/AppSidebar';
import { useDetectMobile } from '@/hooks/useDetectMobile';
import { AppNavbar } from '../organisms/AppNavbar';
import { SidebarInset } from '../atoms/Sidebar';
import ScrollToTop from '@/routes/ScrollToTop';
import { MembershipContentLock } from '@/components/membership/MembershipContentLock';
import { useMembershipPreviewAccess } from '@/hooks/useMembershipPreviewAccess';

type RootlayoutProps = {
  isViewFooter?: boolean;
  bgColor?: string;
};

type SidebarStyle = CSSProperties & {
  '--sidebar-top': string;
  '--sidebar-width': string;
};

const sidebarStyle: SidebarStyle = {
  '--sidebar-top': '0px',
  '--sidebar-width': '220px',
};

const OrderRootLayout = ({ bgColor = 'bg-gr-50', isViewFooter = false }: RootlayoutProps) => {
  useDetectMobile();
  const shouldShowMembershipPreview = useMembershipPreviewAccess();
  // const [isBannerVisible] = useLocalStorage('isBannerVisible', true);

  return (
    <div className="flex h-[100dvh] flex-col">
      <ScrollToTop />

      {/* <section
        className={` transition-all duration-200 ${
          isBannerVisible ? 'h-[48px] opacity-100' : 'h-0 opacity-0'
        }`}
      >
        <InstallBanner />
      </section> */}
      <div className="flex flex-1 overflow-hidden">
        <SidebarProvider
          style={sidebarStyle}
          className="flex h-full bg-white transition-all duration-300"
          defaultOpen={true}
        >
          {/* height 계산된 사이드바 */}

          <AppSidebar />
          <SidebarInset>
            <div className={`z-[5] flex h-full w-full flex-col  ${bgColor}`}>
              {/* 메인 컨텐츠 */}
              <div className="flex w-full">
                <AppNavbar />
              </div>
              <div className="scrollbar w-full flex-1 overflow-y-auto">
                <MembershipContentLock isLocked={shouldShowMembershipPreview}>
                  <Outlet />
                </MembershipContentLock>
                {isViewFooter && <Footer />}
              </div>
            </div>
          </SidebarInset>
        </SidebarProvider>
      </div>
    </div>
  );
};

export default OrderRootLayout;
